import React from 'react';
import { WifiOff, Loader2, CheckCircle } from 'lucide-react';
import { useOffline } from '@/components/OfflineProvider';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export const OfflineBanner: React.FC = () => {
  const { isOffline, hasOfflineData, isSyncing, syncOfflineData } = useOffline();
  const { t } = useTranslation();

  if (!isOffline && !hasOfflineData && !isSyncing) {
    return null;
  }

  if (isSyncing) {
    return (
      <Alert className="border-primary/30">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
        <AlertDescription className="text-foreground">
          {t('common.syncingOfflineData')}...
        </AlertDescription>
      </Alert>
    );
  }

  if (isOffline) {
    return (
      <Alert className="border-accent/40">
        <WifiOff className="h-4 w-4 text-accent" />
        <AlertDescription className="text-foreground">
          {t('common.offlineModeActive')} - {t('common.limitedFunctionsAvailable')}
        </AlertDescription>
      </Alert>
    );
  }

  if (hasOfflineData) {
    return (
      <Alert className="border-secondary/40">
        <CheckCircle className="h-4 w-4 text-primary" />
        <AlertDescription className="flex items-center justify-between">
          <span>{t('common.offlineDataPending')}</span>
          <Button
            size="sm"
            variant="outline"
            onClick={syncOfflineData}
            className="ml-2"
          >
            {t('common.syncNow')}
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};
